import * as angular from "angular";
import template from "./contact-info.html";
import "./contact-info.less";
import {
	NAME_SUFFIX_LIST,
	NAME_TITLE_LIST
} from "../../constants";

export interface ContactInfo {
	Id?: number;
	Title?: string | null;
	FirstName?: string | null;
	MiddleName?: string | null;
	LastName?: string | null;
	Suffix?: string | null;
	DateOfBirth?: string | null;
}

interface ContactSelectOption {
	key: string;
	display: string;
	value?: string;
	show?: boolean;
}

function formatDateOfBirth(date: Date): string {
	const pad = (value: number) => value.toString().padStart(2, "0");

	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T00:00:00`;
}

export interface ContactInfoController {
	contact: ContactInfo;
	isReadonly?: boolean;
}

// eslint-disable-next-line no-redeclare
export class ContactInfoController {
	public birthdate?: Date;
	public opened = false;
	public titleOptions: ContactSelectOption[] = [];
	public suffixOptions: ContactSelectOption[] = [];
	public readonly format = "MM/dd/yyyy";
	public readonly dateOptions = {
		formatYear: "yyyy",
		startingDay: 0,
		minDate: new Date("01/01/1920")
	};
	public readonly altInputFormats = [
		"M!-d!-yyyy", "M!-d!-yy",
		"M!/d!/yyyy", "M!/d!/yy",
		"M!.d!.yyyy", "M!.d!.yy",
		"shortDate"
	];

	public $onInit(): void {
		this.titleOptions = [{ key: "", display: "" }].concat(NAME_TITLE_LIST);
		this.suffixOptions = [{ key: "", display: "" }].concat(
			NAME_SUFFIX_LIST.filter((suffix: ContactSelectOption) => suffix.show === true)
		);

		if(this.contact.DateOfBirth) {
			this.birthdate = new Date(this.contact.DateOfBirth);
		}
	}

	public toggle(): void {
		this.opened = !this.opened;
	}

	public updateBirthday(): void {
		if(this.birthdate) {
			this.contact.DateOfBirth = formatDateOfBirth(this.birthdate);
		}
	}
}

export default angular
	.module("vesl.components.contact-info.contact-info", [])
	.component("contactInfo", {
		controller: ContactInfoController,
		template,
		bindings: {
			contact: "=",
			isReadonly: "<"
		}
	})
	.name;
